import { render, staticRenderFns } from "./FuneralDocuments.vue?vue&type=template&id=59c698aa&scoped=true&"
import script from "./FuneralDocuments.vue?vue&type=script&lang=js&"
export * from "./FuneralDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c698aa",
  null
  
)

export default component.exports